"use client";

import { PromoCardHorizontal as PromoCardHorizontalCore } from "@jti/core-components/components/PromoCardHorizontal";

import type { promoCardHorizontalInputs } from "./PromoCardHorizontal.builder";

type PromoCardHorizontalProps = BuilderComponentProps<typeof promoCardHorizontalInputs>;

export const PromoCardHorizontal = ({
  imageUrl,
  tabletImageUrl,
  desktopImageUrl,
  title,
  description,
  imageAlt,
  dominantColor,
  tabletDominantColor,
  desktopDominantColor,
  url,
}: PromoCardHorizontalProps) => {
  return (
    <PromoCardHorizontalCore
      imageSrc={imageUrl}
      imageSrcTablet={tabletImageUrl || undefined}
      imageSrcDesktop={desktopImageUrl || undefined}
      imageAlt={imageAlt}
      title={title}
      href={url}
      description={description}
      imageContainerBackgroundColor={dominantColor || undefined}
      imageContainerBackgroundColorTablet={tabletDominantColor || undefined}
      imageContainerBackgroundColorDesktop={desktopDominantColor || undefined}
    />
  );
};
